import { HiUser, HiOfficeBuilding } from "react-icons/hi";

const Sidebar = ({ selectedPage, setSelectedPage }) => {
  return (
    <div className="flex flex-col pt-4 pl-2 gap-2 h-full w-[30%] bg-white">
      <button
        className={`flex gap-2 px-4 py-2 items-center text-[16px] hover:bg-slate-500 hover:text-white rounded-lg border border-gray-100 ${
          selectedPage === "personal" ? "bg-slate-500 text-white" : ""
        }`}
        onClick={() => setSelectedPage("personal")}
      >
        <HiUser />
        <span>Personal Details</span>
      </button>
      <button
        className={`flex gap-2 px-4 py-2 items-center text-[16px] hover:bg-slate-500 hover:text-white rounded-lg border border-gray-100 ${
          selectedPage === "company" ? "bg-slate-500 text-white" : ""
        }`}
        onClick={() => setSelectedPage("company")}
      >
        <HiOfficeBuilding />
        <span>Company Details</span>
      </button>
    </div>
  );
};

export default Sidebar;
